module.exports = __webpack_public_path__ + "1.5.0-unryo/img/hyper-v.35a24838.png";